import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import { useMemo } from "react";
import { DialogContent, Grid } from "@material-ui/core";
import accessoriesService from "../../../services/accessories.service";

const initialValues = {
  name: "",
  summery: "",
  description: "",
  brandId: undefined,
  categoryId: undefined,
  isActive: true,
};
const schema = Yup.object().shape({
  name: yupSchema.name,
  summery: yupSchema.summery,
  description: yupSchema.description,
  brandId: yupSchema.brandId,
  categoryId: yupSchema.categoryId,
});

const FormWrapper = ({ children }) => (
  <DialogContent>
    <Grid container spacing={2}>
      {children}
    </Grid>
  </DialogContent>
);

export default function FormModalContent({ close, data, extra }) {
  const errorHandler = useErrorHandler();

  const form = useMemo(
    () => [
      {
        _type: "container",
        name: "col1",
        _wrapper: (props) => <Grid item sm={7} md={6} xs={12} {...props} />,
        form: [
          {
            _type: "textField",
            name: "name",
            label: "نام",
            autoFocus: true,
          },
          {
            _type: "textField",
            name: "description",
            label: "توضیحات",
            multiline: true,
            rows: 10,
          },
        ],
      },
      {
        _type: "container",
        name: "col2",
        _wrapper: (props) => <Grid item sm={5} md={6} xs={12} {...props} />,
        form: [
          {
            _type: "textField",
            name: "summery",
            label: "خلاصه توضیحات",
            multiline: true,
            rows: 4,
          },
          {
            _type: "autocomplete",
            _empty: undefined,
            name: "brandId",
            options: extra?.brands || [],
            label: "برند",
            disableClearable: true,
            valueSelector: "id",
            labelSelector: "name",
          },
          {
            _type: "autocomplete",
            _empty: undefined,
            name: "categoryId",
            options: extra?.categories || [],
            label: "کتوری",
            disableClearable: true,
            valueSelector: "id",
            labelSelector: "name",
          },
          {
            _type: "switch",
            name: "isActive",
            label: "فعال",
          },
        ],
      },
    ],
    [extra]
  );

  const handleSubmit = async (model, { setSubmitting }) => {
    let op;
    if (data?.id) {
      op = await accessoriesService.editAccessory(data.id, model);
    } else {
      op = await accessoriesService.createAccessory(model);
    }
    const { error } = op;
    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };
  return (
    <DialogFormBuilder
      {...{
        close,
        name: "اکسسوری",
        data,
        schema,
        initialValues,
        handleSubmit,
        form,
        formWrapper: FormWrapper,
      }}
    />
  );
}
